import React, { useEffect } from 'react';
import { ContactDataTemplate } from '../subComponents/ContactDataTemplate';
import { UUID } from '../../../../types/shared/UUID';
import { useParams } from 'react-router-dom';
import { createSelector } from '@reduxjs/toolkit';
import { IOrderDetailsData } from '../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { OrderApi, useGetOrderQuery } from '../../../../API/order/OrderApi';
import { PartyContactsTable } from './PartyContactsTable';
import { useAppDispatch } from '../../../../store/store';
import { eAPITags } from '../../../../API/eAPITags';
import { ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../../ui-toolkit/orders/interfaces/IParty';

const isTransactionParty = (party: IParty) =>
  [ePartyPurpose.borrower, ePartyPurpose.buyer, ePartyPurpose.seller].includes(party.purpose);

const selectCertainParties2 = createSelector(
  (res: { data?: IOrderDetailsData }) => res.data?.parties ?? [],
  (parties: IParty[]) => parties.filter(isTransactionParty)
);

export const TransactionContactsContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();

  const dispatch = useAppDispatch();
  useEffect(() => {
    // force a reload everytime on the contacts page in case there's been a mutation through redux slices
    dispatch(OrderApi.util.invalidateTags([{ type: eAPITags.OrderData, id: orderId }]));
  }, [dispatch, orderId]);

  const { selectedParties, error } = useGetOrderQuery(orderId, {
    skip: !orderId,
    selectFromResult: (result) => {
      return { ...result, selectedParties: selectCertainParties2(result) };
    },
  });

  return (
    <ContactDataTemplate
      header={'Parties'}
      hintText={'Buyers, sellers, borrowers, and anyone else associated with the transaction.'}
      rtkError={error}
    >
      <PartyContactsTable selectedParties={selectedParties} />
    </ContactDataTemplate>
  );
};
